import axios from "axios";
import { CHANNEL_URL } from "../../../../../constants/config";

export function getAllChannels(params) {
  return axios.get(`${CHANNEL_URL}/list`, { params });
}
